<template>
  <div>
    <div class="hader">
      <p>
        <span>{{ Number(anIndex) + 1 }}</span>
        <span>[{{ TestItems.Style }}]</span>
        <span v-html="TestItems.Title"></span>
      </p>
    </div>
    <div class="main">
      <!-- 题型有单选和多选 -->
      <template v-if="(TestItems.Answer.length&&TestItems.Answer.length == 1)  || TestItems.Answer.TestType == 'ATEST'">
        <div class="practice_view" v-if="practice">
          <!-- 练习状态 -->
          <ul>
            <li
              v-for="(item, index) in TestItems.SelectedItems"
              :key="index"
              @click="saveAnswer(item.ItemName)"
            >
              <img
                src="@/assets/student/choice.png"
                alt=""
                v-if="practiceColour(item) === 'green'"
              />
              <img
                src="@/assets/student/errorx.png"
                alt=""
                v-else-if="practiceColour(item) === 'red'"
              />
              <div class="default" v-else></div>
              <p :class="practiceColour(item)">
                {{ item.ItemName + "." }}
                <span v-html="item.Content"> </span>
              </p>
            </li>
          </ul>
        </div>
        <!-- 考试 -->
        <div v-else>
          <el-radio-group v-model="UserAnswer">
            <el-radio
              :label="item.ItemName"
              v-for="(item, index) in TestItems.SelectedItems"
              :key="index"
              @change="saveAnswer(item)"
            >
              {{ item.ItemName + "." }}
              <span v-html="item.Content"> </span>
              <!-- {{ item.ItemName + "." + item.Content }} -->
            </el-radio>
          </el-radio-group>
        </div>
      </template>
      <template v-else>
        <!-- 多选 -->
        <el-checkbox-group v-model="UserAnswer" v-if="practice">
          <el-checkbox
            :label="item.ItemName"
            v-for="(item, index) in TestItems.SelectedItems"
            :key="index"
          >
            <p :class="practiceColourX(item.ItemName)">
              {{ item.ItemName + "." }}
              <span v-html="item.Content"> </span>
            </p>
          </el-checkbox>
        </el-checkbox-group>
        <el-checkbox-group v-model="UserAnswer" v-else>
          <el-checkbox
            :label="item.ItemName"
            v-for="(item, index) in TestItems.SelectedItems"
            :key="index"
            @change="saveAnswer(item)"
          >
            <p>
              {{ item.ItemName + "." }}
              <span v-html="item.Content"> </span>
            </p>
          </el-checkbox>
        </el-checkbox-group>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      UserAnswer: null,
    };
  },
  props: ["TestItems", "anIndex", "userAbswerArr", "practice"],
  methods: {
    // 保存答案
    saveAnswer(item) {
      if (this.practice && (this.TestItems.Answer.length == 1 || this.TestItems.TestType == 'ATEST')) {
        // 练习状态进来
        this.UserAnswer = item;
      }
      const AbswerObj = {
        TestID: this.TestItems.TestID,
        ChildTableID: this.practice
          ? this.TestItems.ID
          : this.TestItems.BTestItemID, // 小题干ID
        UserAnswer: this.UserAnswer,
        Score: this.TestItems.Score,
        IsRight: this.UserAnswer == this.TestItems.Answer ? true : false,
      };
      if (this.TestItems.TestType == 'XTEST' || this.TestItems.Answer.length > 1) {
        // 多选
        const myArraytoStringFunction = (input) =>
          input.reduce((a, item) => a + (a === "" ? item : item), "");
        let newarr = this.UserAnswer.sort(); // 答案排序
        let zqAnswer = this.TestItems.Answer.split("").sort().join(""); // 将正确答案进行排序
        AbswerObj.UserAnswer = myArraytoStringFunction(newarr);
        AbswerObj.IsRight =
          myArraytoStringFunction(newarr) == zqAnswer ? true : false;
      }
      this.$emit("userAbswer", AbswerObj);
      // console.log(item, this.TestItems);
      console.log(AbswerObj);
    },
    // 回显用户刷新保存上次答案
    theEchoAbswer() {
      if (!this.practice) {
        // 考试和练习ID不同
        this.userAbswerArr.forEach((item) => {
          if (item.ChildTableID == this.TestItems.BTestItemID) {
            this.UserAnswer = item.UserAnswer;
          }
        });
      } else {
        this.userAbswerArr.forEach((item) => {
          if (
            item.ChildTableID == this.TestItems.ID &&
            item.TestID == this.TestItems.TestID
          ) {
            this.UserAnswer = item.UserAnswer;
          }
        });
      }
      if (this.TestItems.TestType == 'XTEST' || this.TestItems.Answer.length > 1) {
        // 多选
        this.$nextTick(() => {
          let str = this.UserAnswer;
          let str1 = "";
          for (var i = 0; i < str.length; i++) {
            str1 += str[i] + ",";
          }
          str1 = str1.slice(0, -1);
          this.UserAnswer = str1.split(",");
        });
      }
    },
  },
  computed: {
    practiceColour() {
      return function (item) {
        if (this.TestItems.UserAnswer && this.practice) {
          // 练习才触发
          if (
            this.TestItems.UserAnswer == this.TestItems.Answer &&
            item.ItemName == this.TestItems.UserAnswer
          ) {
            // 答案正确且相同
            return "green";
          }
          if (
            this.TestItems.UserAnswer != this.TestItems.Answer
            // &&
            // item.ItemName == this.TestItems.UserAnswer
          ) {
            // 答案错误且相同
            // console.log(this.TestItems.Answer,item.ItemName);
            if (this.TestItems.Answer == item.ItemName) {
              return "green";
            } else if (item.ItemName == this.TestItems.UserAnswer) {
              return "red";
            } else {
              return "";
            }
          } else {
            return "";
          }
        } else {
          return "";
        }
      };
    },
    practiceColourX() {
      return function (item) {
        if (
          this.TestItems.UserAnswer &&
          this.practice &&
          this.TestItems.colourState == true
        ) {
          // 练习状态触发
          if (this.TestItems.Answer.includes(item) == true) {
            return "green";
          } else {
            return "red";
          }
        }
      };
    },
  },
  created() {
    if (this.TestItems.TestType == 'XTEST' || this.TestItems.Answer.length > 1) {
      // 多选
      this.UserAnswer = [];
    }
    this.theEchoAbswer();
  },
};
</script>

<style lang="scss" scoped>
.hader {
  min-height: 68px;
  display: flex;
  // align-items: center;
  background: #f7f7f7;
  user-select: none;
  padding: 12px 24px;
  p {
    text-align: left;
    span {
      &:nth-child(1) {
        color: #119ce5;
        font-weight: bold;
        font-size: 150%;
        margin: 0px 14px 18px 0px;
      }
      &:nth-child(2) {
        color: #119ce5;
        font-weight: bold;
      }
    }
  }
}
.main {
  padding: 36px 30px;
  user-select: none;
  ::v-deep .el-radio-group {
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: flex-start;
    .el-radio__label {
      font-size: 18px;
    }
    .el-radio {
      margin-bottom: 18px;
    }
  }
  ::v-deep .el-checkbox-group {
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: flex-start;
    .el-checkbox {
      margin-bottom: 18px;
      .el-checkbox__label {
        font-size: 18px;
      }
    }
  }
}
.green {
  color: rgb(1, 207, 151);
}
.red {
  color: #ee4f3b;
}
.practice_view {
  > ul {
    list-style-type: none;
    > li {
      display: flex;
      align-items: center;
      font-size: 20px;
      margin-bottom: 12px;
      cursor: pointer;
      > img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
      .default {
        border: 2px solid #d1dde4;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 10px;
        // margin-top:12px;
      }
    }
  }
}
</style>
